/**
 * Preload all the things!
 */
const preload = (src, successCallback) => new Promise(((resolve, reject) => {
  const img = new Image();
  img.onload = function () {
    successCallback(img);
    resolve(img);
  };
  img.onerror = reject;
  img.src = src;
}));

export const preloaderElements = {
  container: document.getElementById('preloader'),
  progress: document.querySelector('.preloader__progress-bar'),
  percent: document.querySelector('.preloader__progress-percent span'),
};

export const isDebugMode = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has('debug');
};

export const preloadAll = (sources, sourceSuccessCallback = () => {}) => Promise.all(
  sources.map((source) => preload(source, sourceSuccessCallback)),
);
